var map = {
	"./bar-chart.svg": "fcee",
	"./category.png": "54a9",
	"./crop.svg": "9ccf",
	"./diagram.png": "5474",
	"./donate.png": "e3b5",
	"./hydrograph.svg": "863c",
	"./icons/back-arrow.svg": "5573",
	"./icons/blue-water.svg": "7435",
	"./icons/business.png": "9a32",
	"./icons/business_disabled.png": "da80",
	"./icons/country.png": "21bd",
	"./icons/crop_for_selector.svg": "247d",
	"./icons/domestic-water.svg": "6aa6",
	"./icons/industry.svg": "75fc7",
	"./icons/left-bottom-radius.svg": "6550",
	"./icons/left-top-radius.svg": "7b09",
	"./icons/location.png": "6673",
	"./icons/location_disabled.png": "d9d2",
	"./icons/product.png": "da9c",
	"./icons/product_disabled.png": "5a21",
	"./icons/raw-product.png": "3176",
	"./icons/raw-product_disabled.png": "5588",
	"./icons/right-bottom-radius.svg": "ccd2",
	"./icons/right-top-radius.svg": "61ac",
	"./icons/river-basin.png": "a2ab",
	"./icons/river-basin_disabled.png": "b8f0",
	"./icons/water-risk.png": "bf5d",
	"./icons/water-risk_disabled.png": "4088",
	"./icons/world.png": "38e6",
	"./icons/world_disabled.png": "d20a",
	"./map.png": "48dd",
	"./map.svg": "a6a4",
	"./mask1.png": "8a42",
	"./mask2.png": "7a5f",
	"./mask3.png": "85ca",
	"./minus.svg": "785a",
	"./pie-chart.svg": "901c",
	"./plus.svg": "2beb",
	"./shape.png": "f4d3",
	"./shape1.png": "793e",
	"./shape1_new.png": "31bf",
	"./shape2.png": "4e70",
	"./shape2_new.png": "60fb",
	"./shape3.png": "e546",
	"./shape3_new.png": "1fe9",
	"./shape_disabled.png": "246b",
	"./subcategory.png": "69bd",
	"./table.svg": "26c6"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "bb6e";